import styled from "styled-components";
import GlobalStyle from "../../../GlobalStyle";

const Button = (props) => {
  return (
    <>
      <GlobalStyle />
      <Btn className={props.className && props.className} onClick={props.onClick} {...props}>
        {props.value}
      </Btn>
    </>
  );
};

export default Button;

const Btn = styled.button`
  border-radius: 27px;
  background-color: #27ce0a;
  color: #ffffff;
  font-size: 22px;
  font-weight: 700;
  padding: 12px 26px;
  line-height: 26px;
  border: none;
  font-family: "helveticaneuebold";
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    /* font-size: 14px; */
    font-size: 16px;
    line-height: 20px;
    padding: 10px 26px;
    font-family: "helvetica_neuemedium_extended";
    /* font-family: "helveticaneueregular"; */
    font-weight: normal;
    letter-spacing: 1px;
  }
  &.btn-sm-primary {
    border-radius: 27px;
    background-color: #27ce0a;
    color: #ffffff;
    font-size: 18px;
    font-weight: 700;
    padding: 6px 16px;
    border: none;
    font-family: "helveticaneuebold";
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 11px;
    }
  }
  &.btn-sm-secondary {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    border-radius: 22.5px;
    background-color: #ffffff;
    color: #27ce0a;
    font-size: 18px;
    font-weight: 700;
    padding: 6px 12px;
    box-shadow: inset 0 0 0 1.75px #27ce0a;
    font-family: "helveticaneuebold";
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 11px;
    }
  }
  &.btn-lg-secondary {
    border-radius: 27px;
    background-color: #ffffff;
    color: #27ce0a;
    font-size: 22px;
    font-weight: 700;
    padding: 12px 26px;
    line-height: 26px;
    box-shadow: inset 0 0 0 1.75px #27ce0a;
    font-family: "helveticaneuebold";
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 14px;
    }
  }
  &:active,
  &:focus {
    box-shadow: 0 0 0 0.2rem rgb(40 167 69 / 50%);
  }
  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`;
